/**
 * VISUAL-SEARCH-001-R4A — suggest thumbnail URL.
 * Prom images are filename-sized (_w640_h640_). Fabricated ?w=&q= broke loads on Android.
 * Use canonical MINI variant; CSS scales to 48–64px.
 */
import { miniImageUrl } from "./product-media-v2.js";

export function suggestionThumbUrl(raw: string | null | undefined): string | null {
  const url = String(raw ?? "").trim();
  if (!url || !/^https?:\/\//i.test(url)) return null;
  try {
    const u = new URL(url);
    // Strip fabricated resize query params from 169A that break Prom CDN.
    if (u.searchParams.has("w") || u.searchParams.has("q") || u.searchParams.has("width")) {
      const w = u.searchParams.get("w");
      const q = u.searchParams.get("q");
      // Only strip our prior fabricated pair
      if (w === "64" && q === "60") {
        u.searchParams.delete("w");
        u.searchParams.delete("q");
      }
    }
    return miniImageUrl(u.toString());
  } catch {
    return miniImageUrl(url);
  }
}
